import React, { useState } from 'react'
import { graphql, useStaticQuery } from 'gatsby'
import { motion } from 'framer-motion'
import { faqIds } from '../components/data'

import Banner from '../components/banner'
import Layout from '../components/layouts/mainLayout'

import "../styles/faq.scss"

const FAQ = () => {

    const data = useStaticQuery(graphql`
      query {

        BannerImg: file(relativePath: {eq:"faq-banner.jpg"}){
          ...FluidImageFragment
        }
      }
  `)

    const [expanded, setExpanded] = useState();

    return (
        <Layout>
            <Banner 
                title="FAQ"
                img={data.BannerImg.childImageSharp.fluid}
                height="small"
            />
            <div className="faq-container" id="prospects">
                {faqIds.map((details, index) => (
                    <>
                        <FAQContent key={index} details={details} expanded={expanded} setExpanded={setExpanded} />
                        <div className="linebreak"></div>
                    </>  
                ))}
            </div>
        </Layout>
    )
}

const FAQContent = ({ details, expanded, setExpanded }) => {
    const isOpen = details.id === expanded
    return (
        <>
            <div className="faq-question"
            onClick={() => setExpanded(isOpen ? false : details.id)}>  
                <div className="dropdown-icon">
                    <h3>{details.question}</h3>
                    <motion.span
                        animate={{rotate: isOpen ? 0 : 90, x: 8}}
                        transition={{duration: 0.2, ease: [0.6, 0.05, -0.01, 0.9]}}
                    ></motion.span>
                    <motion.span></motion.span>
                </div>
                <motion.div className="faq-content" key="content"
                    animate={{height: isOpen ? '100%' : '0'}}
                    transition={{duration: 0.6, ease: [0.6, 0.05, -0.01, 0.9]}}
                >
                    {details.answer}
                </motion.div>
            </div>
            
        </>
    )
}

export default FAQ
